export const ruMessages = {
  "errorOccurred": "Произошла ошибка. Обновите страницу.",
  "archiveFragmentUnavailable": "На данной камере запрошенный фрагмент архива недоступен",
  "analyticsZonesHints": "Подсказки для редактирования зон аналитики",
  "addPointToZone": "Чтобы добавить точку для зоны, кликните по видео.",
  "removePointFromZone": "Чтобы удалить точку из текущей зоны, кликните по точке.",
  "removeAllPointsFromZone": "Чтобы удалить все точки из текущей зоны, нажмите на кнопку \"Очистить\".",
  "movePoint": "Зажмите кнопку мыши на точке и переместите ее, чтобы изменить ее положение.",
  "editZonesIndividually": "Нельзя редактировать все зоны одновременно, только по отдельности.",
  "selectZoneToEdit": "Выберите из выпадающего списка зону чтобы отредактировать ее. Учтите, что цвета зон не сохраняются.",
  "maxPointsInZone": "Максимум в одной зоне может быть 100 точек.",
  "acceleratedVideo": "Ускоренное видео",
  "analyticsZone": "Зона аналитики",
  "availableZones": "Доступные зоны",
  "showAll": "Показать все",
  "sensitivity": "Чувствительность",
  "deleteAllPointsInZone": "Удалить все точки на текущей зоне",
  "refreshPage": "Обновить страницу",
  "from": "От",
  "to": "До",
  "download": "Скачать",
  "cancel": "Отменить",
  "clean": "Очистить",
  "saveAllZones": "Сохранить все зоны",
  "save": "Сохранить",
  "showHelp": "Показать справку",
  "zoomOutArchiveScale": "Отдалить шкалу архива",
  "zoomInArchiveScale": "Приблизить шкалу архива",
  "goToCurrentMoment": "Перейти к текущему моменту",
  "archiveCalendar": "Календарь архива",
  "goToLiveStream": "Перейти к прямой трансляции",
  "rewindBack15s": "Отмотать назад на 15 секунд",
  "launch": "Запустить",
  "pause": "Пауза",
  "fastForward15s": "Промотать вперед на 15 секунд",
  "ptzControl": "PTZ управление",
  "takeScreenshot": "Сделать скриншот",
  "videoAnalysisZones": "Зоны для анализа видео",
  "playbackSpeed": "Скорость воспроизведения",
  "downloadArchive": "Скачать архив",
  "volume": "Громкость",
  "settings": "Настройки",
  "streams": "Потоки",
  "noDelayStream": "Прямой эфир без задержки",
  "fullscreen": "Развернуть на весь экран",
  "close": "Закрыть",
  "confirm": "Подтвердить",
  "alertMessage": "Обратитесь к администратору.",
  "alertDialogTitle": "Сообщение",
  "confirmDialogTitle": "Подтвердите действие",
  "promptDialogTitle": "Внимание",
  "deleteRow": "Удалить строку",
  "addRow": "Добавить строку",
  "addRowTitle": "Добавить строку",
  "selectFromList": "Выберите из списка",
}
